module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/inline-style-prefixer@2.0.5/~/inline-style-prefixer/static.js
// module id = 378
// module chunks = 0